export enum UsageType {
  ProTokens = 'pro-tokens',
  LowTokens = 'low-tokens',
  AutomationRuns = 'automation-runs',
  Webhooks = 'webhooks',
}
